function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M33.162 4.56435C32.7731 3.11848 31.6331 1.97871 30.1874 1.58939C27.5464 0.86676 16.982 0.86676 16.982 0.86676C16.982 0.86676 6.41804 0.86676 3.77699 1.56199C2.35914 1.9509 1.19136 3.11868 0.802444 4.56435C0.107422 7.20518 0.107422 12.6819 0.107422 12.6819C0.107422 12.6819 0.107422 18.1863 0.802444 20.7995C1.19177 22.2452 2.33133 23.385 3.7772 23.7743C6.44585 24.4971 16.9824 24.4971 16.9824 24.4971C16.9824 24.4971 27.5464 24.4971 30.1874 23.8019C31.6333 23.4128 32.7731 22.273 33.1624 20.8273C33.8572 18.1863 33.8572 12.7097 33.8572 12.7097C33.8572 12.7097 33.885 7.20518 33.162 4.56435ZM13.6185 17.7416V7.62232L22.4033 12.6819L13.6185 17.7416Z",
  fill: "white"
});

function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 25,
    viewBox: "0 0 34 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.a3f2bc73.svg";
export { ForwardRef as ReactComponent };